import { Heading, Text } from '@chakra-ui/react'
import { FormikProps } from 'formik'
import React from 'react'
import { UnifiedField } from 'src/components/DynamicForm/DynamicForm'
import i18n from 'src/i18n'
import { CartDetails, UserType } from 'src/redux/cart/types'
import * as Yup from 'yup'

export const getInputFields = (formik: FormikProps<CartDetails>): UnifiedField[] => {
  const { postalAddress, streetAddress } = formik.values[UserType.Receiver]
  const selectedAddress = `${streetAddress}, ${postalAddress.postal_code} ${postalAddress.municipality_name}`

  return [
    {
      jsx: (
        <Heading as='h3' size='md' marginBottom={3}>
          {i18n.t('common.pickupAddressTitle')}
        </Heading>
      ),
      key: 'pickupAddressTitle',
    },
    {
      jsx: (
        <Text fontSize='md' marginBottom={3} fontStyle='italic'>
          {selectedAddress}
        </Text>
      ),
      key: 'pickupAddress',
    },
    {
      jsx: (
        <Heading as='h3' size='md' marginBottom={3}>
          {i18n.t('common.collectionDateTitle')}
        </Heading>
      ),
      key: 'collectionDateTitle',
    },
    {
      id: 'collectionDate',
      type: 'date',
      key: 'collectionDate',
    },
    {
      jsx: (
        <Heading as='h3' size='md' marginBottom={3} marginTop={3}>
          {i18n.t('common.billingInformationTitle')}
        </Heading>
      ),
      key: 'billingInformationTitle',
    },
    {
      id: 'firstName',
      title: i18n.t('common.firstName'),
      type: 'input',
    },
    {
      id: 'lastName',
      title: i18n.t('common.lastName'),
      type: 'input',
    },
    {
      id: 'email',
      title: i18n.t('common.email'),
      type: 'input',
    },
    {
      id: 'phoneNumber',
      title: i18n.t('common.phoneNumber'),
      type: 'input',
    },
    {
      id: 'additionalInfo',
      title: i18n.t('common.additionalInfo'),
      type: 'textarea',
    },
  ]
}

export const getValidationSchema = () =>
  Yup.object().shape({
    firstName: Yup.string().required(i18n.t('validation.firstNameRequired')),
    lastName: Yup.string().required(i18n.t('validation.lastNameRequired')),
    email: Yup.string()
      .email(i18n.t('validation.invalidEmail'))
      .required(i18n.t('validation.emailRequired')),
    phoneNumber: Yup.string().min(9).required(i18n.t('validation.phoneNumberRequired')),
    additionalInfo: Yup.string(),
  })
